import NormalBtn from './StockItems/NormalBtn';
import GoogleLogin from 'react-google-login';
import WagmiWrap from './WagmiWrap';
import ReallyConnectButton from './ReallyConnectButton';

function App(props) {

  var responseGoogleYes = props.responseGoogleYes;
  var width = props.width;
  var chains = props.chains;
  var reallySignIn = props.reallySignIn;
  var randomCode = props.randomCode;
  var userID = props.userID;


  function responseGoogleFail(response){
    console.log(response);
  }


  var style = {};
  if (width){
    style.width = width;
  }

  var inside = <div className='container py-5' style={style}>
        <div className="row" ><div className="col-lg-8 mx-auto text-center">
        <ReallyConnectButton reallySignIn={reallySignIn} randomCode={randomCode} userID={userID}/>
        <br/><br/>  
        <GoogleLogin
          clientId="549662522339-6iq5nc8u80rd07ri0nmbtgg5lh58cneo.apps.googleusercontent.com"
          onSuccess={responseGoogleYes}
          onFailure={responseGoogleFail}
          render={renderProps => (<NormalBtn iconStyle={{marginBottom:'3px'}} title='Sign in via Google' onClick={renderProps.onClick} icon='akar-icons:google-fill' oppositeColor={true}/>)}
          cookiePolicy={'single_host_origin'}
        />
        </div></div></div>

    return <WagmiWrap inside={inside} currencyID={0} chains={chains} />
//
}

export default App;
